/* =========================================================
   THE GLOW DUO — page behaviour
   Prices, cart links and button wording come from the JSON the hero
   section prints ([data-gd-config]); this file never computes a price
   or writes customer-facing text of its own.

   Every init is idempotent: it binds each element once, so the whole
   thing can re-run after the theme editor re-renders a section.
   ========================================================= */
(function () {
  if (window.__glowDuoInit) return;
  window.__glowDuoInit = true;

  function track(name, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'glow_duo_' + name }, detail || {}));
    } catch (e) {}
  }

  // true the first time it is called for this element + key
  function once(el, key) {
    var attr = 'gdBound' + key;
    if (el.dataset[attr]) return false;
    el.dataset[attr] = '1';
    return true;
  }

  function getConfig() {
    var el = document.querySelector('[data-gd-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function init() {
    var config = getConfig();
    if (config) {
      initOffer();
      initBuyLinks(config);
      initDock();
    }
    initGallery();
    initCountdown();
    initTabs();
    initReviewsToggle();
    initVideo();
  }

  /* ---------- offer picker ---------- */
  function applyOption(form, key) {
    var config = getConfig();
    var opt = config && config.options[key];
    if (!opt) return;

    var cta = form.querySelector('[data-gd-cta]');
    cta.href = opt.url;
    form.querySelector('[data-gd-cta-label]').textContent = opt.cta;

    var note = form.querySelector('[data-gd-note]');
    if (note) note.innerHTML = opt.note || '';

    var nudge = form.querySelector('[data-gd-nudge]');
    if (nudge) {
      form.querySelector('[data-gd-nudge-text]').innerHTML = opt.nudge || '';
      nudge.classList.toggle('is-visible', !!opt.nudge);
    }

    var dock = document.querySelector('[data-gd-dock]');
    if (dock) {
      dock.querySelector('[data-gd-dock-name]').textContent = opt.name;
      dock.querySelector('[data-gd-dock-price]').textContent = opt.price;
      dock.querySelector('[data-gd-dock-compare]').textContent = opt.compare || '';
      dock.querySelector('[data-gd-dock-cta]').href = opt.url;
      dock.querySelector('[data-gd-dock-label]').textContent = opt.dock;
    }
  }

  function initOffer() {
    var form = document.querySelector('[data-gd-offer]');
    if (!form) return;

    if (once(form, 'Offer')) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') {
          applyOption(form, e.target.value);
          track('select', { option: e.target.value });
        }
      });
      form.querySelector('[data-gd-cta]').addEventListener('click', function () {
        var checked = form.querySelector('input[type="radio"]:checked');
        track('checkout', { option: checked ? checked.value : 'duo', placement: 'hero' });
      });
    }

    var checked = form.querySelector('input[type="radio"]:checked');
    applyOption(form, checked ? checked.value : 'duo');
  }

  // "Switch to the duo" and any other [data-gd-pick] control, wherever it is
  document.addEventListener('click', function (e) {
    var pick = e.target.closest && e.target.closest('[data-gd-pick]');
    if (!pick) return;
    var form = document.querySelector('[data-gd-offer]');
    var input = form && form.querySelector('input[value="' + pick.getAttribute('data-gd-pick') + '"]');
    if (!input) return;
    input.checked = true;
    applyOption(form, input.value);
    track('select', { option: input.value, via: 'nudge' });
  });

  /* ---------- every other buy link and price on the page ---------- */
  function initBuyLinks(config) {
    document.querySelectorAll('[data-gd-buy]').forEach(function (el) {
      var key = el.getAttribute('data-gd-buy');
      var opt = config.options[key];
      if (!opt) return;
      el.href = opt.url;
      if (once(el, 'Buy')) {
        el.addEventListener('click', function () {
          track('checkout', { option: key, placement: el.getAttribute('data-gd-placement') || 'page' });
        });
      }
    });
    document.querySelectorAll('[data-gd-price]').forEach(function (el) {
      var opt = config.options[el.getAttribute('data-gd-price')];
      if (opt) el.textContent = opt.price;
    });
    document.querySelectorAll('[data-gd-compare]').forEach(function (el) {
      var opt = config.options[el.getAttribute('data-gd-compare')];
      if (opt) {
        el.textContent = opt.compare || '';
        el.hidden = !opt.compare;
      }
    });
  }

  /* ---------- sticky buy bar ----------
     Shown once the hero button has scrolled away, hidden again while the
     closing band (it has its own button) is on screen. Elements are looked
     up on every frame, so a re-rendered section needs no rebinding. */
  var dockBound = false;
  // Fixed bottom bars from apps (the cookie consent banner) would cover the dock, so the dock
  // sits on top of whichever of them is showing and drops back down once it is dismissed.
  var COVERS = '#cb-cookie_consent .cb-cookie_consent-container';
  var lastOffset = -1;

  function syncDockOffset() {
    var vh = window.innerHeight;
    var offset = 0;
    document.querySelectorAll(COVERS).forEach(function (el) {
      if (!el.offsetHeight || getComputedStyle(el).visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > vh - 4) offset = Math.max(offset, Math.round(vh - r.top));
    });
    if (offset === lastOffset) return;
    lastOffset = offset;
    document.documentElement.style.setProperty('--gd-dock-offset', offset + 'px');
  }

  function updateDock() {
    var dock = document.querySelector('[data-gd-dock]');
    var hero = document.querySelector('[data-gd-cta]');
    if (!dock || !hero) return;
    syncDockOffset();
    var vh = window.innerHeight;
    var show = hero.getBoundingClientRect().bottom < 0;
    document.querySelectorAll('[data-gd-hide-dock]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) show = false;
    });
    dock.classList.toggle('is-visible', show);
    document.documentElement.classList.toggle('gd-dock-open', show);
    dock.setAttribute('aria-hidden', show ? 'false' : 'true');
    dock.querySelector('[data-gd-dock-cta]').tabIndex = show ? 0 : -1;
  }

  function initDock() {
    var dock = document.querySelector('[data-gd-dock]');
    if (!dock) return;
    if (once(dock, 'Dock')) {
      dock.querySelector('[data-gd-dock-cta]').addEventListener('click', function () {
        var checked = document.querySelector('[data-gd-offer] input[type="radio"]:checked');
        track('checkout', { option: checked ? checked.value : 'duo', placement: 'dock' });
      });
    }
    if (!dockBound) {
      dockBound = true;
      var ticking = false;
      var onScroll = function () {
        if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; updateDock(); }); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      // the banner is injected after load and removed on dismiss without any scroll
      setInterval(syncDockOffset, 700);
    }
    updateDock();
  }

  /* ---------- hero gallery ----------
     Native scroll-snap does the swiping; this only keeps the arrows and
     thumbnails in step with the scroll position. */
  function galleryGo(rail, i) {
    var slides = rail.children;
    i = Math.max(0, Math.min(slides.length - 1, i));
    rail.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
  }

  function initGallery() {
    document.querySelectorAll('[data-gd-gallery]').forEach(function (root) {
      var rail = root.querySelector('[data-gd-gallery-track]');
      if (!rail || !once(root, 'Gallery')) return;
      var prev = root.querySelector('[data-gd-gallery-prev]');
      var next = root.querySelector('[data-gd-gallery-next]');
      var thumbs = root.querySelectorAll('[data-gd-gallery-thumb]');
      var current = 0;
      var seen = false;

      function indexFromScroll() {
        var x = rail.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        Array.prototype.forEach.call(rail.children, function (s, i) {
          var d = Math.abs(s.offsetLeft - x);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        // at the far end the last slides may never reach the left edge
        if (x > 0 && x + rail.clientWidth >= rail.scrollWidth - 2) best = rail.children.length - 1;
        return best;
      }

      function render() {
        current = indexFromScroll();
        var last = rail.children.length - 1;
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = current >= last;
        thumbs.forEach(function (t, i) {
          var on = i === current;
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on && t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
            t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          }
        });
        if (current > 0 && !seen) { seen = true; track('gallery_swipe'); }
      }

      var raf = 0;
      rail.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; render(); });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { galleryGo(rail, current - 1); });
      if (next) next.addEventListener('click', function () { galleryGo(rail, current + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { galleryGo(rail, parseInt(t.getAttribute('data-gd-gallery-thumb'), 10)); });
      });
      rail.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); galleryGo(rail, current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); galleryGo(rail, current - 1); }
      });
      window.addEventListener('resize', render);
      render();
    });
  }

  /* ---------- countdown ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-gd-countdown]').forEach(function (wrap) {
      var end = Date.parse(wrap.getAttribute('data-ends'));
      var clock = wrap.querySelector('[data-gd-clock]');
      if (isNaN(end) || !clock || !once(wrap, 'Countdown')) return;

      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var ms = end - Date.now();
        if (ms <= 0) { wrap.hidden = true; return false; }
        var s = Math.floor(ms / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        clock.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
        wrap.hidden = false;
        return true;
      }
      if (tick()) {
        var t = setInterval(function () { if (!tick() || !wrap.isConnected) clearInterval(t); }, 1000);
      }
    });
  }

  /* ---------- review tabs ---------- */
  function selectTab(tabs, tab) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-gd-tabs]').forEach(function (root) {
      if (!once(root, 'Tabs')) return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.gd-tabs [role="tab"]'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { selectTab(tabs, tab); });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
          var next = tabs[(i + tabs.length) % tabs.length];
          next.focus();
          selectTab(tabs, next);
        });
      });
    });
  }

  /* ---------- mobile: full review widget behind a button ---------- */
  function initReviewsToggle() {
    document.querySelectorAll('[data-gd-reviews-toggle]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel || !once(btn, 'Toggle')) return;
      btn.addEventListener('click', function () {
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
        btn.hidden = true;
        track('reviews_open');
      });
    });
  }

  /* ---------- video: load the player only when asked ---------- */
  function initVideo() {
    document.querySelectorAll('[data-gd-video]').forEach(function (btn) {
      if (!once(btn, 'Video')) return;
      btn.addEventListener('click', function () {
        var frame = document.createElement('iframe');
        frame.src = btn.getAttribute('data-gd-video');
        frame.title = btn.getAttribute('aria-label') || 'Video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        btn.replaceWith(frame);
        track('video_play');
      });
    });
  }

  /* ---------- theme editor ----------
     Re-run after a section re-renders, and bring a selected block into view:
     a gallery photo scrolls the gallery, an FAQ opens, a review card slides in. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var rail = el.closest('[data-gd-gallery-track]');
    if (rail) {
      galleryGo(rail, Array.prototype.indexOf.call(rail.children, el.closest('.gd-gallery__slide')));
      return;
    }
    if (el.tagName === 'DETAILS') { el.open = true; return; }
    if (el.closest('.gd-review-cards')) { el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
